import React from 'react';
import Box from '../../hoc/Box/Box';
import Spinner from '../../components/UI/Spinner/Spinner';
import api from '../../axios-local-api';
import classes from './Devices.css';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { FaSync } from 'react-icons/fa';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import ErrorAlert from '../../shared/Alert/ErrorAlert';
import Modal from '../../components/UI/Modal/Modal';
import Error from '../../components/UI/Error/Error';
import { EquipmentTypes } from '../../shared/common';


export class Devices extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceRefreshed: false
    }
  }

  refreshDevicesHandler() {
    this.props.onRefreshDevices(this.props.selectedEquipment);
    this.setState({
      deviceRefreshed: true
    });
  }

  handleErrorModalClose = () => {
    this.setState({
      deviceRefreshed: false
    })
  }

  render() {
    // console.log(this.props, "props")
    let infoRow;
    const selectedType = this.props.selectedEquipment ? this.props.selectedEquipment.type : '';
    let featureFlags = sessionStorage.getItem('featureFlags');
    let speedBoostCount = null


    if (
      this.props.loading ||
      !this.props.loaded ||
      (this.props.wan && this.props.wan.checkingWan) ||
      (this.props.wan && this.props.wan.podTimer && this.props.wan.rebootPodId)
    ) {

      infoRow = <Spinner />
    } else if(this.props.errorStatus) {
      infoRow = (
        <ErrorAlert />
      )
    }else if (!this.props.devicesByEquipment) {

      infoRow = (
        <div id= 'devicesNoDevice' style={{ color: 'gray' }}>
          There is no Device Information available at this time
        </div>
      )
    } else {

      const thereExistsEquipment = (
        this.props.devicesByEquipment &&
        this.props.devicesByEquipment.length &&
        (selectedType === EquipmentTypes.Equipment || (selectedType === EquipmentTypes.Router && !this.props.wan.checkingWan) || (selectedType === EquipmentTypes.Pod && !this.props.wan.podTimer))
      )

      const devicesCount = thereExistsEquipment ? this.props.devicesByEquipment.length : 0;

      const devicesConn = thereExistsEquipment ? this.props.devicesByEquipment.filter(elem => elem.connectionState === 'connected') : 0;

      const devicesConnected = thereExistsEquipment ? devicesConn.length : 0;

      const devicesPaus = thereExistsEquipment ? this.props.devicesByEquipment.filter(elem => elem.freeze.frozen === true) : 0;

      const devicesPaused = thereExistsEquipment ? devicesPaus.length : 0;

      let boostedDevicesCount = 0;
      if(thereExistsEquipment){
        const speedBoostDevices = this.props.speedBoostDevices.devices && this.props.speedBoostDevices.devices.filter(element => {
          return element.boostStatus === 'BOOSTED';
        });
        const macSet = speedBoostDevices && speedBoostDevices.map(elem => elem.clientMac);
        boostedDevicesCount = macSet && this.props.devicesByEquipment.filter(ele => { 
          const macFilter = ele.mac.replaceAll(':', '');
          return macSet.includes(macFilter)
        }); 
    }

    if (featureFlags && featureFlags.includes('speedBoost') && this.props.speedBoostDevices && this.props.speedBoostDevices.eligible) {

      speedBoostCount = (
        <Box>
          <div className={[classes.showDesktop, classes.Separator].join(' ')} />
          <div className={classes.InfoItem}>
            <h1 id="boosteddevices" style={{ color: '#0073d1' }}>{boostedDevicesCount?.length ?? 0}/4</h1>
            <div className={classes.SmallInfoRow} >
              <div className={classes.showDesktop} style={{ textAlign: 'center' }}>Boosted Devices </div>
              <div className={classes.showMobile} style={{ textAlign: 'center' }}>Boosted</div>
            </div>
          </div>
        </Box>
      )
    }

      infoRow = (
        <Box>
          <div className={classes.InfoItem}>
            <h1 id="totaldevices" style={{ color: '#0073d1' }}>{devicesCount}</h1>
            <div className={classes.showDesktop} style={{ textAlign: 'center' }}>Total Devices </div>
            <div className={classes.showMobile} style={{ textAlign: 'center' }}>Total</div>
          </div>

          <div className={[classes.showDesktop, classes.Separator].join(' ')} />

          <div className={classes.InfoItem}>
            <h1 id="connectedDevicesTotal" style={{ color: '#0073d1' }}>{devicesConnected}</h1>
            <div className={classes.SmallInfoRow} >
              <div id='connectedDevices' className={classes.showDesktop} style={{ textAlign: 'center' }}>Connected Devices </div>
              <div className={classes.showMobile} style={{ textAlign: 'center' }}>Connected</div>
            </div>
          </div>

          {
            selectedType === EquipmentTypes.Router || selectedType === EquipmentTypes.Pod
              ? null
              : <div className={[classes.showDesktop, classes.Separator].join(' ')} />
          }

          {
            selectedType === EquipmentTypes.Router || selectedType === EquipmentTypes.Pod
              ? null
              : (
                <div className={classes.InfoItem}>
                  <h1 id="disconnectedDevicesTotal" style={{ color: '#0073d1' }}>{devicesCount - devicesConnected}</h1>
                  <div className={classes.SmallInfoRow} >
                    <div className={classes.showDesktop} style={{ textAlign: 'center' }}>Disconnected Devices </div>
                    <div className={classes.showMobile} style={{ textAlign: 'center' }}>Disconnected</div>
                  </div>
                </div>
              )
          }

          <div className={[classes.showDesktop, classes.Separator].join(' ')} />

          <div className={classes.InfoItem}>
            <h1 id="pauseddevices" style={{ color: '#0073d1' }}>{devicesPaused}</h1>
            <div className={classes.SmallInfoRow} >
              <div className={classes.showDesktop} style={{ textAlign: 'center' }}>Paused Devices </div>
              <div className={classes.showMobile} style={{ textAlign: 'center' }}>Paused</div>
            </div>
          </div>

          {speedBoostCount}

        </Box>
      )
    }

    return (

      <Box>
        <div className={classes.Devices}>
          <div className={classes.TitleArea}>
            <h3 style={{ paddingRight: 20 }}>Devices</h3>
            <button
              id="Refreshbtn"
              className={classes.RegularButton}
              onClick={() => { this.refreshDevicesHandler() }}
            >
              <FaSync />  Refresh
            </button>
          </div>

          <div className={classes.HorizontalSeparator} />

          <div className={classes.InfoRow}>
            {infoRow}
          </div>
        </div>
        <Modal
          show={this.props.error && this.props.refresh && this.state.deviceRefreshed}
          modalClosed={this.handleErrorModalClose}
        >
          <Error id={'DeviceDetailsError'} errorStatus={this.props.errorStatus} showOldView />
        </Modal>
      </Box >
    )
  }
}

const mapStateToProps = state => (
  {
    loading: state.devices.loading,
    loaded: state.devices.loaded,
    account: state.settings.account,
    realSettings: state.settings.realSettings,
    isAuthenticated: state.auth.token !== null, isPinxt: state.auth.pToken !== null,
    isDummy: state.auth.isDummy,
    wan: state.wan,
    speedBoostDevices: state.speedBoost.speedBoostDevices,
    error: state.devices.error,
    refresh: state.devices.refresh,
    errorStatus: state.devices.errorStatus
  }
)

const mapDispatchToProps = (dispatch) => (
  {
    onRefreshDevices: (selectedEquipment) => dispatch(actions.refreshDevices(selectedEquipment)),
    onGetAdvancedDeviceIds: (deviceMacs, days) => dispatch(actions.getAdvancedDeviceIds(deviceMacs, days)),
    onResetDevicesErrorSuccess: () => {
      dispatch(actions.resetDevicesErrorSuccess());
    },
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Devices, api));

